<ul class='gov-stepper'>
  @for (item of stageList(); track item) {
    <li class='gov-stepper__step' [ngClass]="item.status" [innerHTML]="item.name"></li>
  }
</ul>
